import React, { useState, useEffect } from "react";

import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { TextField } from "@mui/material";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";

import IconButton from "@mui/material/IconButton";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";

import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Typography from "@mui/material/Typography";

import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

import Chip from "@mui/material/Chip";

import dayjs from "dayjs";

import Header from "./components/header";
import { useNavigate } from "react-router-dom";

import axios from "axios";

const boxStyles = {
  my: 1,
  display: "flex",
  justifyContent: "space-between",
  fontSize: "1.2em",
};

const commonStyles = {
  p: 2,
  mb: 2,
  border: 1,
  borderRadius: "4px",
  borderColor: "#e8e8e8",
};

let service_options = [
  { id: "Reumatologie", label: "Reumatologie" },
  { id: "Recuperare Medicala", label: "Recuperare Medicala" },
];

const dayNames = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function AddDoctor() {
  let navigate = useNavigate();

  const [docApi, setDocApi] = useState({});
  const [slotApi, setSlotApi] = useState([]);
  const [notification, setNotification] = useState(false);

  const createDocApi = async () => {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + `/doctors/`,
      docApi
    );
    if ((response.statusText = "OK")) {
      // console.log("saved doc", response);

      let slot = {
        weekslots: true,
        doctor: response.data._id,
        service_type: response.data.specialitate,
        slot_duration: slotApi.slot_duration,
      };

      const response_slot = await axios.post(
        process.env.REACT_APP_API_URL + `/slots/`,
        slot
      );
      if ((response_slot.statusText = "OK")) {
        // console.log("saved doc slot", response_slot);
        setNotification(true);
        navigate("/doctors/" + response.data._id);
      }
    }
  };

  const handleSave = () => {
    // console.log("create doctor");
    createDocApi();
  };

  const handleChange = ({ target: { name, value } }) => {
    // console.log("edit_change", name, value);

    setDocApi({
      ...docApi,
      [name]: value,
    });
  };

  const handleCloseNotification = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setNotification(false);
  };

  return (
    <>
      <Header></Header>

      <Snackbar
        open={notification}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={1000}
        onClose={handleCloseNotification}
      >
        <Alert
          onClose={handleCloseNotification}
          severity="success"
          sx={{ width: "100%" }}
        >
          Saved Changes!
        </Alert>
      </Snackbar>
      <Container maxWidth="xl">
        <Grid
          container
          alignItems="center"
          direction="row"
          justifyContent="space-between"
        >
          <Grid item xs={10}>
            <Typography variant="h4" sx={{ mt: 3 }}>
              Add new Doctor
            </Typography>
          </Grid>
          <Grid item xs={2} sx={{ textAlign: "right" }}></Grid>
        </Grid>
        <Paper elevation={3} sx={{ mt: 3, p: 2 }}>
          <Grid
            container
            alignItems="center"
            direction="row"
            justifyContent="space-between"
          >
            <Grid item xs={4}>
              <FormControl sx={{ mr: 1, width: "calc(100% - 8px)" }}>
                <TextField
                  fullWidth
                  name="name"
                  label="Nume"
                  id="name"
                  required
                  value={docApi.name ?? ""}
                  onChange={handleChange}
                ></TextField>
              </FormControl>
            </Grid>
            <Grid item xs={2}>
              <FormControl sx={{ mr: 1, width: "calc(100% - 8px)" }}>
                <TextField
                  fullWidth
                  select
                  required
                  label="Service"
                  name="specialitate"
                  id="demo-simple-select-filled"
                  value={docApi.specialitate ?? ""}
                  onChange={(event, newValues) => {
                    // console.log(newValues);
                    handleChange({
                      target: {
                        name: "specialitate",
                        value: newValues.props.value,
                      },
                    });
                  }}
                >
                  {service_options.map((opt) => (
                    <MenuItem key={opt.id} value={opt.id}>
                      {opt.label}
                    </MenuItem>
                  ))}
                </TextField>
              </FormControl>
            </Grid>
            <Grid item xs={2}>
              <FormControl sx={{ mr: 1, width: "calc(100% - 8px)" }}>
                <TextField
                  fullWidth
                  name="email"
                  label="Email"
                  id="email"
                  value={docApi.email ?? ""}
                  onChange={handleChange}
                ></TextField>
              </FormControl>
            </Grid>
            <Grid item xs={2}>
              <FormControl sx={{ mr: 1, width: "calc(100% - 8px)" }}>
                <TextField
                  fullWidth
                  name="phone"
                  label="Telefon"
                  id="phone"
                  value={docApi.phone ?? ""}
                  onChange={handleChange}
                ></TextField>
              </FormControl>
            </Grid>
            <Grid item xs={2}>
              <FormControl sx={{ mr: 1, width: "calc(100% - 8px)" }}>
                <TextField
                  fullWidth
                  name="duration"
                  label="Slot Duration"
                  id="duration"
                  required
                  value={slotApi.slot_duration ?? ""}
                  onChange={(e) => {
                    setSlotApi({ ...slotApi, slot_duration: e.target.value });
                  }}
                ></TextField>
              </FormControl>
            </Grid>
          </Grid>
        </Paper>
        <Button
          variant="contained"
          color="error"
          size="large"
          fullWidth
          sx={{ mt: 3 }}
          disabled={
            docApi.name === undefined ||
            docApi.name === "" ||
            docApi.specialitate === undefined ||
            docApi.specialitate === "" ||
            slotApi.slot_duration === undefined ||
            slotApi.slot_duration === ""
              ? true
              : false
          }
          onClick={handleSave}
        >
          Add Doctor
        </Button>

        <Box sx={{ mb: 10 }}></Box>
      </Container>
    </>
  );
}
